import React from "react";
import Slider from "./slider";
import Units from "./units";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateUnitFromTo } from "../../store/reducers/filterSlice";

class Range extends React.Component {
  state = {};

  constructor(props) {
    super(props);

    this.changeFromTo = (from, to) => {
      this.props.updateUnitFromTo({
        option: this.props.range.option,
        from: from,
        to: to,
      });
    };
  }
  render() {
    return (
      <>
        {
          <div className="filter-row ranges">
            <h4>{this.props.range.title}</h4>
            <Units range={this.props.range} />
            <div className="clear-both"></div>
            {Object.entries(this.props.range.classes).map((rangeClass, i) =>
              rangeClass[1].units.map((unit) => {
                if (
                  unit.class == this.props.selectedClass &&
                  Object.hasOwn(
                    this.props.selectedRange,
                    this.props.range.option
                  ) &&
                  this.props.selectedRange[this.props.range.option].unit ==
                    unit.unit
                ) {
                  return (
                    <Slider
                      min={unit.min}
                      max={unit.max}
                      id={this.props.range.option}
                      changeFromTo={this.changeFromTo}
                    />
                  );
                }
              })
            )}
          </div>
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedClass: state.filter.request.class,
    selectedRange: state.filter.request.range,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateUnitFromTo: (args) => (dispatch) => {
        dispatch(updateUnitFromTo(args));
      },
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Range);
